export const getAll = () => document.cookie.split("; ").reduce((prev, current) => {
    const [name, value] = current.split("=");
    prev[name] = value;
    return prev;
}, {});
export const getCookie = (key) => {
    const cookieObj = getAll();
    return key.length ? cookieObj[key] : cookieObj;
};
export const setCookie = (name, value, path, expires) => {
    const ckValue = getCookie(name);
    if (ckValue === value || ckValue === value.toString()) {
        return;
    }
    const cookiePath = path ? `; path=${path}` : "";
    const expiryDate = expires ? `; expires=${expires}` : "";
    document.cookie = `${name}=${value}${cookiePath}${expiryDate}`;
};
export const removeCookie = (name, path = "/") => {
    setCookie(name, "", path, "Thu, 01 Jan 1970 00:00:00 GMT");
};
//# sourceMappingURL=cookies.js.map